import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from '@mui/material';
import EditTableHeader from './EditTableHeader';
import _ from 'lodash';
import { formatColumnValue } from '../../../../hooks/Formatter';
import TablePagination from '@mui/material/TablePagination';

const useStyles = makeStyles({
  table: {
    minWidth: 800,
    borderCollapse: "separate !important",
    borderSpacing: "0 16px !important",
    border: "none !important"
  },
  tableRow: {
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 16px 0px rgba(0, 0, 0, 0.10)"
  },
  tableHead: {
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 16px 0px rgba(0, 0, 0, 0.10)",
    borderSpacing: "0 !important",
  },
  tableCell: {
    padding: "5px 20px!important"
  }
});

const headCells = [
  {
    id: 'EntityType',
    numeric: true,
    disablePadding: true,
    label: 'Entity Type',
    filterOptions: ["Division", "PL3"],
  },
  {
    id: 'Name',
    numeric: true,
    disablePadding: false,
    label: 'Name',
    filterOptions: ["Nestle Coffee Partners", "Sweet Earths", "International Brands", "US SBUX INSTANT", "US MN BOOST"],
  },
  {
    id: 'AlertType',
    numeric: true,
    disablePadding: false,
    label: 'Alert Type',
    filterOptions: ["Projected Cost Increase", "Truckload Increase", "Cost Reduction Opportunity", "Payload Decrease"],
  },
  {
    id: 'Threshold',
    numeric: true,
    disablePadding: false,
    label: 'Threshold',
    // filterOptions: ["20000", "5", "50%", "2"],
  },
  {
    id: 'Unit',
    numeric: true,
    disablePadding: false,
    label: 'Units',
    filterOptions: ["Dollars", "Truckload"],
  },
];

const headCellsForIF = [
  {
    id: 'Entity',
    numeric: true,
    disablePadding: true,
    label: 'Entity Type',
    filterOptions: ["Division", "PL3"],
  },
  {
    id: 'Network',
    numeric: true,
    disablePadding: false,
    label: 'Name',
    filterOptions: ["Nestle Coffee Partners", "Sweet Earths", "International Brands", "US SBUX INSTANT", "US MN BOOST"],
  },
  {
    id: 'Insight_Type',
    numeric: true,
    disablePadding: false,
    label: 'Insight Type',
    filterOptions: ["Projected Cost Increase", "Truckload Increase", "Cost Reduction Opportunity", "Payload Decrease"],
  },
  {
    id: 'Threshold',
    numeric: true,
    disablePadding: false,
    label: 'Threshold',
    // filterOptions: ["20000", "5", "50%", "2"],
  },
  {
    id: 'Units',
    numeric: true,
    disablePadding: false,
    label: 'Units',
    filterOptions: ["Dollars", "Truckload"],
  },
];

export default function EditTable({ filteredRows, _handleSave, handleClickRowChange, fileData }) {
  const classes = useStyles();
  // const [order, setOrder] = useState('asc');
  const order = 'asc';
  // const [orderBy, setOrderBy] = useState('calories');
  const orderBy = 'calories';
  const [selected, setSelected] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const [rows, setRows] = useState([]);
  const [sortBy, setSortBy] = useState('Units');
  const [sortOrder, setSortOrder] = useState('asc');
  // const [thresholdValues, setThresholdValues] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  //const rowsPerPage = 100; // Number of rows to display per page
  const [rowsPerPage, setRowsPerPage] = useState(100);


  const paginatedRows = useMemo(() => {
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return rows.slice(startIndex, endIndex);
  }, [rows, currentPage, rowsPerPage]);

  const handleRequestSort = (property) => {
    const isAsc = sortBy === property && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortBy(property);
  };

  const handleOpen = (event, value) => {
    setAnchorEl(event.currentTarget);
    setSelectedMenuIndex(value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOption = (event) => {
    const { value } = event.target;
    const updatedOptions = [...checkedOptions];

    if (value === 'all') {
      const allOptions = (window.location.pathname === "/if" ? headCellsForIF : headCells)?.flatMap(cell => cell?.filterOptions);
      setCheckedOptions(allOptions);
      setIsAllSelected(true);
    } else {
      const columnIndex = selectedMenuIndex;
      const indexInColumn = updatedOptions[columnIndex].indexOf(value);

      if (indexInColumn === -1) {
        updatedOptions[columnIndex].push(value);
      } else {
        updatedOptions[columnIndex].splice(indexInColumn, 1);
      }
      setCheckedOptions(updatedOptions);
      setIsAllSelected(false);
    }
  };

  const handleAllSelectOption = (_headCellId, _headCell) => {
    if (selectedMenuIndex === "ALL") {
      setSelectedMenuIndex(null);
    } else {
      setSelectedMenuIndex("ALL");
    }
  };

  const handleCheckboxSelect = (newCheckedOptions, column, _isChecked) => {
    let updatedRows = filteredRows;
    const newFilteredRows = updatedRows.filter(row => newCheckedOptions[column].includes(row[column]));
    setRows(newFilteredRows);
  };

  const handleAllCheckboxSelect = (isChecked) => {
    if (isChecked) {
      setRows(filteredRows);
    } else {
      setRows([]);
    }
  };

  const handleClick = (_event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  function descendingComparator(a, b, orderBy) {
    if (orderBy === 'Threshold') {
      return b[orderBy] - a[orderBy];
    }
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const debouncedHandleClickRowChange = useCallback(
    _.debounce((row, value) => {
      const updatedRow = { ...row, Threshold: value };

      // Create a new list ensuring no duplicates and with the latest value
      const updatedRows = selectedRows.reduce((acc, val) => {
        // Check if the row matches based on unique identifiers
        if (val.EntityType === updatedRow.EntityType &&
          val.Name === updatedRow.Name &&
          val.AlertType === updatedRow.AlertType) {
          // Prioritize non-empty Threshold values
          if (updatedRow.Threshold || val.Threshold) {
            // Remove old row with the same unique identifiers
            acc = acc.filter(item => !(item.EntityType === updatedRow.EntityType &&
              item.Name === updatedRow.Name &&
              item.AlertType === updatedRow.AlertType));
            acc.push(updatedRow); // Add the updated row
          }
          return acc;
        }
        acc.push(val); // Keep existing row if it does not match
        return acc;
      }, []);

      // If the updated row does not exist in the list, add it
      if (!updatedRows.some(val => val.EntityType === updatedRow.EntityType &&
        val.Name === updatedRow.Name &&
        val.AlertType === updatedRow.AlertType)) {
        updatedRows.push(updatedRow);
      }
      // Update state and handle additional operations
      setSelectedRows(updatedRows);
      handleClickRowChange(updatedRows);
    }, 1000),
    [selectedRows]
  );


  const handleRowChange = (event, id, row) => {
    const { value } = event.target;
    debouncedHandleClickRowChange(row, value);
    const updatedRows = rows.map((row, index) =>
      index === id ? { ...row, Threshold: value } : row
    );
    setRows(updatedRows);
  };

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  useEffect(() => {
    const updatedRows = filteredRows.map((row, _index) => ({
      ...row,
      Threshold: row.Threshold
    }));

    const sortedData = stableSort(updatedRows, getComparator(sortOrder, sortBy));
    setRows(sortedData);
  }, [filteredRows, sortOrder, sortBy]);

  return (
    <TableContainer sx={{ p: 1, maxHeight: 500, overflow: 'visible', top: 0 }}>
      <Table stickyHeader className={classes.table} aria-labelledby="tableTitle" size="medium">
        <EditTableHeader
          onRequestSort={handleRequestSort}
          order={order}
          orderBy={orderBy}
          anchorEl={anchorEl}
          handleOpen={handleOpen}
          handleClose={handleClose}
          handleSelectOption={handleSelectOption}
          handleAllSelectOption={handleAllSelectOption}
          selectedMenuIndex={selectedMenuIndex}
          checkedOptions={checkedOptions}
          isAllSelected={isAllSelected}
          rows={rows}
          headCells={window.location.pathname === "/if" ? headCellsForIF : headCells}
          handleCheckboxSelect={handleCheckboxSelect}
          handleAllCheckboxSelect={handleAllCheckboxSelect}
        />
        <TableBody style={{ fontSize: "14px" }}>
          {paginatedRows?.map((row, index) => {
            const isItemSelected = isSelected(row?.id);
            const labelId = `enhanced-table-checkbox-${index}`;
            return (
              <TableRow
                hover
                onClick={(event) => handleClick(event, index)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={labelId}
                className={classes.tableRow}
                selected={isItemSelected}
                sx={{ cursor: 'pointer', fontSize: "10px" }}
              >
                <TableCell className={classes.tableCell} style={{ color: "#062760" }}>
                  {window.location.pathname === "/if" ? row?.Entity : row?.EntityType}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {window.location.pathname === "/if" ? row?.Network : row?.Name}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <div style={{ backgroundColor: "#FDF8E6", borderRadius: "4px", padding: "0px 10px", textAlign: "center", width: "fit-content" }}>
                    {
                    window.location.pathname === "/if" 
                    ? formatColumnValue(row?.Insight_Type)
                    : formatColumnValue(row?.AlertType) === 'Cost Per Case' ? 'Cost Per Case Increase' : formatColumnValue(row?.AlertType)}
                  </div>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <TextField
                    size="small"
                    sx={{
                      width: '100px',
                      '& .MuiInputBase-input': {
                        height: '15px',
                        borderRadius: "20px",
                        fontSize: "13px",
                        borderColor: 'transparent',
                        textAlign: "center"
                      },
                    }}
                    disabled={fileData?.length !== 0}
                    name="Threshold"
                    // value={thresholdValues[index] || ''}
                    value={row?.Threshold}
                    onChange={(event) => handleRowChange(event, index, row)}
                  />
                </TableCell>
                <TableCell className={classes.tableCell}>
                  { window.location.pathname === "/if" ? row?.Units : row?.Unit}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[50, 100, 200]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={(_event, newPage) => setCurrentPage(newPage)}
        onRowsPerPageChange={(event) => {
          setCurrentPage(0); // Reset to first page
          //rowsPerPage = parseInt(event.target.value, 10);
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </TableContainer>
  );
}
